import Svg from 'components/utilities/svg'

const SearchOffIcon = ({ ...props }) => (
  <Svg viewBox="0 96 960 960" {...props}>
    <title>Search Off Icon</title>
    <path d="M280 976q-83 0-141.5-58.5T80 776q0-83 58.5-141.5T280 576q83 0 141.5 58.5T480 776q0 83-58.5 141.5T280 976Zm544-40L568 680q-12-13-25.5-26.5T516 628q38-24 61-64t23-88q0-75-52.5-127.5T420 296q-75 0-127.5 52.5T240 476q0 6 .5 11.5T242 499q-18 2-39.5 8T164 521q-2-11-3-22t-1-23q0-109 75.5-184.5T420 216q109 0 184.5 75.5T680 476q0 43-13.5 81.5T629 628l251 252-56 56Zm-615-61 71-71 70 71 29-28-71-71 71-71-28-28-71 71-71-71-28 28 71 71-71 71 28 28Z" />
  </Svg>
)

SearchOffIcon.displayName = 'SearchOff'

export default SearchOffIcon
